import { css, _beta_popoverTokens as tokens } from '@salutejs/plasma-new-hope/css';
import {
    onDarkTextSecondary,
    onDarkTextSecondaryActive,
    onDarkTextSecondaryHover,
    shadowDownHardM,
    surfaceAccent,
    surfaceSolidCard,
    textSecondary,
    textSecondaryActive,
    textSecondaryHover,
} from '@salutejs/sdds-themes/tokens/sdds_finai';

export const config = {
    defaults: {
        view: 'action',
        size: 'm',
    },
    variations: {
        view: {
            action: css`
                ${tokens.backgroundColor}: ${surfaceSolidCard};
                ${tokens.boxShadow}: ${shadowDownHardM};
                ${tokens.iconColor}: ${textSecondary};
                ${tokens.iconColorHover}: ${textSecondaryHover};
                ${tokens.iconColorActive}: ${textSecondaryActive};
            `,
            info: css`
                ${tokens.backgroundColor}: ${surfaceAccent};
                ${tokens.boxShadow}: ${shadowDownHardM};
                ${tokens.iconColor}: ${onDarkTextSecondary};
                ${tokens.iconColorHover}: ${onDarkTextSecondaryHover};
                ${tokens.iconColorActive}: ${onDarkTextSecondaryActive};
            `,
        },
        size: {
            m: css`
                ${tokens.borderRadius}: 1rem;
                ${tokens.padding}: 0.75rem 0.5rem 0.5rem 0.5rem;
                ${tokens.iconOffset}: 0.625rem;
                ${tokens.tailWidth}: 20px;
                ${tokens.tailHeight}: 8px;
                ${tokens.tailSideCurvature}: -10%;
            `,
            s: css`
                ${tokens.borderRadius}: 0.75rem;
                ${tokens.padding}: 0.5rem 0.375rem 0.375rem 0.375rem;
                ${tokens.iconOffset}: 0.5rem;
                ${tokens.tailWidth}: 20px;
                ${tokens.tailHeight}: 8px;
                ${tokens.tailSideCurvature}: -10%;
            `,
        },
    },
};
